import { createContext, useContext, useState, useCallback, ReactNode } from "react";
import { PaywallModal } from "@/components/PaywallModal";
import { trackConversion } from "@/lib/conversionTracking";
import type { OpenPaywallSource } from "@/types/paywall";

const PaywallModalContext = createContext<{
  openPaywall: (source?: OpenPaywallSource) => void;
}>({ openPaywall: () => {} });

export function usePaywallModal() {
  return useContext(PaywallModalContext);
}

/** Opens paywall modal with plan choice (Pro Solo/Pro Growth), monthly/annual, founding; Unlock opens Lenco with correct amount. */
export function PaywallModalProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const [source, setSource] = useState<OpenPaywallSource | undefined>(undefined);

  const openPaywall = useCallback((source?: OpenPaywallSource) => {
    setSource(source);
    setOpen(true);
    trackConversion("paywall_viewed", { source: source ?? "unknown" });
  }, []);

  return (
    <PaywallModalContext.Provider value={{ openPaywall }}>
      {children}
      <PaywallModal
        open={open}
        source={source}
        onOpenChange={(nextOpen) => {
          setOpen(nextOpen);
          if (!nextOpen) setSource(undefined);
        }}
      />
    </PaywallModalContext.Provider>
  );
}
